/**
 * Wrong type definition in TSC @see https://github.com/ajv-validator/ajv/issues/2310#issuecomment-1650153200
 * @param input {any} - alternative type (shouldn't contain defaults)
 */
export const schemaNullableField = <T>(input: T): T => {
  return { anyOf: [input, { type: "null" }] } as T;
};
